import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3512fda8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-overlay" }
const _hoisted_2 = { class: "relative flex items-center justify-center py-5" }
const _hoisted_3 = { class: "headline3" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-around pb-5"
}
const _hoisted_5 = {
  key: 1,
  class: "max-h-[20vh] pb-5"
}
const _hoisted_6 = { key: 0 }

import AButton from "@/components/Base/AButton.vue";
import { useStore } from "@/composables/useTypedStore";
import { generateUUID } from "@ionic/cli/lib/utils/uuid";
import { IonButton, IonCol, IonGrid, IonIcon, IonItem, IonLabel, IonList, IonRow } from "@ionic/vue";
import { analyticsOutline, arrowBack, closeCircleOutline, locationOutline, tabletLandscapeOutline } from 'ionicons/icons';
import { computed, ComputedRef, Ref, ref } from "vue";
import { useI18n } from "vue-i18n";

type GeometryType = "point" | "line" | "polygon" | "";


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordGeometry',
  props: {
    currentPosition: {
        type: Object,
        required: true
    }
},
  emits: [
    "recordedGeometry",
    "deleteGeometry"
],
  setup(__props, { emit }) {

const props = __props;



const store = useStore();
const { t } = useI18n({ useScope: 'global' });
const geometryType: Ref<GeometryType> = ref("");
const recordedFeature: Ref<any> = ref({
    type: "Feature",
    geometry: {
        type: "MultiPoint",
        coordinates: [],
    },
    properties: {
        isRecordFeature: true,
        isRecorded: false,
    },
    id: null
});

const titleText = computed(() => {
    if (geometryType.value === "point") {
        return t('hzba.record.recordPoint');
    } else if (geometryType.value === "line") {
        return t('hzba.record.recordLine');
    } else if (geometryType.value === "polygon") {
        return t('hzba.record.recordPolygon');
    } else {
        return t('hzba.record.selectGeometry');
    }
});

const coordinatesArray: ComputedRef<any[]> = computed(() => {
    return recordedFeature.value.geometry.type === "Polygon" ? recordedFeature.value.geometry.coordinates[0] : recordedFeature.value.geometry.coordinates;
});

function resetRecordedFeature(): void {
    recordedFeature.value = {
        type: "Feature",
        geometry: {
            type: "MultiPoint",
            coordinates: [],
        },
        properties: {
            isRecordFeature: true,
            isRecorded: false,
        },
        id: null
    };
}

function setGeometryType(type: GeometryType) {
    recordedFeature.value.id = generateUUID();
    recordedFeature.value.geometry.coordinates = [];
    geometryType.value = type;
}

const isRecordDisabled: ComputedRef<boolean> = computed(() => {
    if (geometryType.value === "point") {
        return recordedFeature.value.geometry.coordinates.length > 0;
    } else {
        return false;
    }
});

const isCompleteDisabled: ComputedRef<boolean> = computed(() => {
    if ( geometryType.value === "point" ){
        return recordedFeature.value.geometry.coordinates.length < 1;
    } else if (geometryType.value === "line") {
        return recordedFeature.value.geometry.coordinates.length < 2;
    } else if ( geometryType.value === "polygon" ) {
        return recordedFeature.value.geometry.coordinates.length < 3;
    } else {
        return true;
    }
});

// // HELPERS FOR TESTING
// let angle = 0;
// const radius = 0.001; // Adjust the radius to control the size of the circle
// const maxSteps = 36; // Number of points to simulate (higher for smoother circle)
// const center = { lon: props.currentPosition.lon, lat: props.currentPosition.lat };

function recordGeometry(): void {
    // // HELPERS FOR TESTING
    // const lon = center.lon + radius * Math.cos(angle);
    // const lat = center.lat + radius * Math.sin(angle);
    // const alt = props.currentPosition.altitude;
    // //Increment the angle to create the next point around the circle
    // angle += (2 * Math.PI) / maxSteps;
    const lon = props.currentPosition.lon;
    const lat = props.currentPosition.lat;
    const alt = props.currentPosition.altitude;
    recordedFeature.value.geometry.coordinates.push([lon, lat, alt]);
    emit("recordedGeometry", { isFinal: false, feature: convertFeature() });
}


function finishRecording(): void {
    if (!recordedFeature.value.geometry.coordinates.length || !geometryType.value) {
        return;
    }
    recordedFeature.value.properties.isRecorded = true;
    emit("recordedGeometry", { isFinal: true, feature: convertFeature() });
}

function closeMenu(): void {
    emit("deleteGeometry", recordedFeature.value.id);
    resetRecordedFeature();
    
    store.dispatch("app/setRecordGeometryOpen", false);
}

function goBack(): void {
    setGeometryType("");
}

function deletePosition( index: number ): void {
    recordedFeature.value.geometry.coordinates.splice(index, 1);
    if ( recordedFeature.value.geometry.coordinates.length > 0) {
        emit("recordedGeometry", { isFinal: false, feature: convertFeature() });
    } else {
        emit("deleteGeometry", recordedFeature.value.id);
    }
    
}

function convertFeature(): any {
    const multiPointFeature = recordedFeature.value;

    if (!multiPointFeature || multiPointFeature.geometry.type !== "MultiPoint") {
        return null;
    }

    const coordinates = [...multiPointFeature.geometry.coordinates]; // Clone coordinates for immutability

    if (coordinates.length === 0) {
        return null;
    }

    const converted = {
        type: "Feature",
        properties: { ...multiPointFeature.properties }, // Clone properties
        geometry: {},
        id: multiPointFeature.id,
    };

    // Handle single coordinate: Always a Point
    if (coordinates.length === 1) {
        converted.geometry = {
            type: "Point",
            coordinates: coordinates[0],
        };
    }
    // Convert to Point
    else if (geometryType.value === "point") {
        converted.geometry = {
            type: "Point",
            coordinates: coordinates[0], // Use the first coordinate
        };
    }
    // Convert to LineString
    else if (geometryType.value === "line" || (geometryType.value === "polygon" && coordinates.length === 2)) {
        converted.geometry = {
            type: "LineString",
            coordinates: coordinates,
        };
    }
    // Convert to Polygon
    else if (geometryType.value === "polygon" && coordinates.length >= 3) {
        converted.geometry = {
            type: "Polygon",
            coordinates: [
                [...coordinates, coordinates[0]], // Add closing coordinate
            ],
        };
    } else {
        return null; // Unsupported case
    }

    return converted;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (geometryType.value)
        ? (_openBlock(), _createBlock(_unref(IonButton), {
            key: 0,
            fill: "clear",
            class: "absolute left-2",
            onClick: goBack
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                size: "large",
                icon: _unref(arrowBack)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(titleText.value), 1),
      _createElementVNode("div", {
        class: "absolute right-2",
        onClick: closeMenu
      }, [
        _createVNode(_unref(IonIcon), {
          size: "large",
          class: "closeIcon",
          icon: _unref(closeCircleOutline)
        }, null, 8, ["icon"])
      ])
    ]),
    (!geometryType.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(IonButton), {
            fill: "clear",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setGeometryType('point')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                size: "large",
                icon: _unref(locationOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonButton), {
            fill: "clear",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setGeometryType('line')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                size: "large",
                icon: _unref(analyticsOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          }),
          _createVNode(_unref(IonButton), {
            fill: "clear",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setGeometryType('polygon')))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonIcon), {
                slot: "icon-only",
                size: "large",
                icon: _unref(tabletLandscapeOutline)
              }, null, 8, ["icon"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (geometryType.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_unref(IonGrid), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonCol), {
                    size: "4",
                    class: "flex items-center justify-center flex-col"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AButton, {
                        class: "mb-5 w-full max-w-[240px] sm:w-60 box-border text-center",
                        "btn-primary": true,
                        disabled: isRecordDisabled.value,
                        onClick: recordGeometry
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('hzba.buttons.recordPoint')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(AButton, {
                        class: "mb-5 w-full max-w-[240px] sm:w-60 box-border text-center",
                        "btn-primary": true,
                        disabled: isCompleteDisabled.value,
                        onClick: finishRecording
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('hzba.buttons.abschliessen')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonCol), {
                    size: "8",
                    class: "pr-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonList), { class: "coordList" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coordinatesArray.value, (coordinate, index) => {
                            return (_openBlock(), _createBlock(_unref(IonItem), {
                              key: index,
                              class: "coordItem"
                            }, {
                              default: _withCtx(() => [
                                (typeof coordinate[0] === 'number' && typeof coordinate[1] === 'number' && typeof coordinate[1] === 'number')
                                  ? (_openBlock(), _createBlock(_unref(IonLabel), { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(coordinate[1]?.toFixed(6)) + ", " + _toDisplayString(coordinate[0]?.toFixed(6)) + " ", 1),
                                        (coordinate[2])
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, " | " + _toDisplayString(coordinate[2]?.toFixed(6)) + " m", 1))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createVNode(_unref(IonButton), {
                                  fill: "clear",
                                  onClick: ($event: any) => (deletePosition(index))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      slot: "icon-only",
                                      size: "medium",
                                      icon: _unref(closeCircleOutline)
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})